<mat-card>
  <mat-card-content>
    <mat-card-title>
      Accesso
    </mat-card-title>
    <br />
      <div class="row">
        <div fxFlex="33%;" fxFlex.xs="100%">
          <button mat-raised-button
                  color="primary" (click)="btnCreaProfilo()">
            Crea profilo
          </button>
        </div>

        <div fxFlex="33%;" fxFlex.xs="100%">
          <button mat-raised-button
                  color="primary" (click)="btnAccedi()">
            Accedi
          </button>
        </div>

        <div fxFlex="33%;" fxFlex.xs="100%">
          <button mat-raised-button
                  color="primary" (click)="btnRecuperaPassword()">
            Recupera password
          </button>
        </div>
      </div>


  </mat-card-content>
</mat-card>
